import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Avatar from '@mui/material/Avatar'
import TvIcon from '@mui/icons-material/Tv';
import { withStyles } from '@mui/styles';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button
} from '@mui/material'

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  avatar: {
    margin: 10,
  },
  greenAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: 'rgba(71,237,62,1)',
  }
});

class IPTV extends Component {
  state = {
    value: 0,
    openAlert: false,
    alertMessage: '',
    removeUUID: ''
  };

  componentDidMount() {
    this.props.reload()
  }

  handleRemoveDevice = (device) => {
    this.setState({
      openAlert: true,
      alertMessage: "Please, confirm you want to remove device " + device.title + ".",
      removeUUID: device.uuid
    });
  }

  handleSendRemove = () => {
    this.setState({
      openAlert: false
    });
    this.props.remove(this.state.uuid)
  }
  handleAlertClose = () => {
    this.setState({
      openAlert: false
    });
  };

  render() {
    const {
      classes
    } = this.props
    return (
      <div>
        < AppBar position = "static"
        style = {
          {
            marginLeft: 260,
            backgroundColor: "#55565A"
          }
        } >
          <Toolbar>
            <Typography variant="title">
              My IPTV Devices
          </Typography>
          </Toolbar>
        </AppBar>
        <Paper style={{
          marginTop: 2,
          marginLeft: 300,
          width: 300
        }}>

          <List >
            {
              this.props.iptv.map(n => {
                return (
                  <ListItem key={n.uuid} >
                    < Avatar className={
                      n.disabled === "true" ? classes.avatar : classes.greenAvatar
                    } >
                      < TvIcon />
                    </Avatar>
                    <ListItemText primary={n.title} secondary={n.type} />
                    <ListItemSecondaryAction >
                      <IconButton disabled={n.type === "SDZapperSTB" ? true : false} onClick={this.handleRemoveDevice.bind(this, n)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}


          </List>
        </Paper>
        <Dialog
          open={
            this.state.openAlert
          }
          onClose={this.handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.alertMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAlertClose} style={{ color: 'white' }} autoFocus>
              CANCEL
            </Button>
            <Button onClick={this.handleSendRemove} style={{ color: 'white' }} autoFocus>
              CONFIRM
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    )

  }
}
export default withStyles(styles)(IPTV)